import { Link } from "react-router-dom";
import AdminLayout from "@/components/feature/AdminLayout";
import LiveClock from "./components/LiveClock";
import ActiveShifts from "./components/ActiveShifts";
import WeeklyTimesheets from "./components/WeeklyTimesheets";

export default function TimeClockPage() {
  return (
    <AdminLayout>
      <div className="px-4 md:px-8 py-6 md:py-8 max-w-[1600px] mx-auto space-y-6">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4">
          <div>
            <div className="flex items-center gap-2 text-xs text-ink-500 mb-2">
              <span>Operations</span>
              <i className="ri-arrow-right-s-line"></i>
              <span className="text-ink-900 font-semibold">Time Clock</span>
            </div>
            <h1 className="font-display text-3xl md:text-4xl font-bold text-ink-900 leading-tight">
              Time Clock & Timesheets
            </h1>
            <p className="text-sm text-ink-500 mt-1.5 max-w-xl">
              Live shift tracking and payroll-ready timesheets for everyone on the clock.
            </p>
          </div>
          <div className="flex items-center gap-2">
            <Link
              to="/m/timeclock"
              className="inline-flex items-center gap-2 px-4 py-2.5 rounded-md text-sm font-semibold border border-ink-200 bg-white text-ink-700 hover:bg-cream-100 cursor-pointer whitespace-nowrap"
              title="Admin preview — crew receive their own private link"
            >
              <i className="ri-smartphone-line"></i>
              Preview Mover App
            </Link>
            <button className="inline-flex items-center gap-2 px-4 py-2.5 rounded-md text-sm font-semibold border border-ink-200 bg-white text-ink-700 hover:bg-cream-100 cursor-pointer whitespace-nowrap">
              <i className="ri-history-line"></i>
              Timesheet History
            </button>
            <button className="inline-flex items-center gap-2 px-4 py-2.5 rounded-md text-sm font-semibold bg-brand-500 hover:bg-brand-600 text-white cursor-pointer whitespace-nowrap">
              <i className="ri-login-box-line"></i>
              Manual Clock In
            </button>
          </div>
        </div>

        {/* Top grid */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 md:gap-5">
          <div className="lg:col-span-1">
            <LiveClock />
          </div>
          <div className="lg:col-span-2">
            <ActiveShifts />
          </div>
        </div>

        {/* Timesheets full width */}
        <WeeklyTimesheets />
      </div>
    </AdminLayout>
  );
}